import { HelperService } from 'src/app/shared/helper.service';
import { AbstractTopBannerType } from '../top-banner-type.abstract';
import { ServiceLocator } from 'src/app/shared/service-locator.service';

export class LayeredPurchasingTopBannerType extends AbstractTopBannerType {
	public largeBannerClassName = 'layered-purchasing-banner';
	public smallBannerClassName = '';
	public bannerHeaderHtml = `
		<span class="semibold-text align-middle">Have you considered a </span>
		<span class="bold-text align-middle">layered purchasing strategy?</span>
	`;

	private helperService: HelperService;

	constructor() {
		super();
		this.helperService = ServiceLocator.injector.get(HelperService);
	}

	public async onActionClicked() {
		this.helperService.openAboutLayeredPurchasingModal();
	}
}
